import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import App from './App';
import './index.css';
import './i18n';
import { captureUtmsFromUrl } from './lib/utm';
import { initPostHog } from './lib/analytics/posthog';
import { installDomGuard } from './lib/domGuard';

installDomGuard();
captureUtmsFromUrl();
initPostHog();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.dispatchEvent(new Event('render-event'));
  });
});